import { render, staticRenderFns } from "./LeaveKanban.vue?vue&type=template&id=552a686c"
import script from "./LeaveKanban.vue?vue&type=script&lang=js"
export * from "./LeaveKanban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports